import _get from 'lodash/get';
import _sortBy from 'lodash/sortBy';

export const sortCoursesByDate = (courses, dateField = 'createdAt', isReverse = false) => {
  const noDateCourses = courses.filter((c) => !_get(c, dateField, undefined));
  const hasDateCourses = courses.filter((c) => _get(c, dateField, null) !== null);

  hasDateCourses.sort(function (a, b) {
    const dateA = _get(a, dateField);
    const dateB = _get(b, dateField);
    return new Date(dateA) - new Date(dateB);
  });

  if (isReverse) {
    hasDateCourses.reverse();
  }
  const formattedCourses = [...hasDateCourses, ...noDateCourses];

  return formattedCourses;
};

export const sortCoursesByName = (courses, isReverse = false) => {
  const sortedCourses = _sortBy(courses, ({ courseInfo }) => courseInfo.title);
  if (isReverse) sortedCourses.reverse();
  return sortedCourses;
};

export const sortCoursesByProgress = (courses) => {
  const sortedCourses = _sortBy(
    courses,
    ({ courseInfo }) => courseInfo.classroomProgress.progressPercent
  ).reverse();
  return sortedCourses;
};

export const getAvailableCourses = (courses, isExpired = false) => {
  const today = new Date();
  return courses.filter(({ courseInfo }, index) => {
    if (courseInfo.classroomProgress.expiryDate === null && isExpired === false) {
      return courses[index];
    } else if (courseInfo.classroomProgress.expiryDate !== null) {
      const courseExpiryDate = new Date(courseInfo.classroomProgress.expiryDate);
      return courseExpiryDate > today !== isExpired;
    }
  });
};

export const getSectionCount = (sections = []) => {
  const sectionCount = sections.length;
  const subsectionCount = sections.reduce((acc, curr) => {
    const { subSections = [] } = curr || {};
    const subsectionCount = subSections.length;
    return acc + subsectionCount;
  }, 0);
  return { sectionCount: sectionCount, subsectionCount };
};
